var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDioxin05(_ref, svgRef) {
  var {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 1072.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_42",
    "data-name": "Ebene 42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,891c8.83,0,8.83-8.25,17.66-8.25S26.49,891,35.31,891s8.83-8.25,17.66-8.25S61.8,891,70.63,891s8.83-8.25,17.65-8.25S97.11,891,105.94,891v44.62L0,945.58Z",
    style: {
      fill: "#9bc6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.08,932.46c-1.53-4.45-7.67-7.77-15-7.77a23.4,23.4,0,0,0-5.2.58,28.48,28.48,0,0,1,1.41,7.19Z",
    style: {
      fill: "#3faaae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,932.46H47.27a28.48,28.48,0,0,0-1.41-7.19C41,926.41,37.19,929.12,36,932.46Z",
    style: {
      fill: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.06,924.69a21,21,0,0,1,9.65,2.2v-5.07a14.74,14.74,0,0,0-2.51-.21,13.39,13.39,0,0,0-8.88,3.15C49.89,924.72,50.47,924.69,51.06,924.69Z",
    style: {
      fill: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.08,932.46c-1.53,4.45-7.67,7.77-15,7.77a23.4,23.4,0,0,1-5.2-.58,28.48,28.48,0,0,0,1.41-7.19Z",
    style: {
      fill: "#35858a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,932.46H47.27a28.48,28.48,0,0,1-1.41,7.19C41,938.51,37.19,935.8,36,932.46Z",
    style: {
      fill: "#e7e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.51,937.69a6.71,6.71,0,0,1-6.27-3.54,7.61,7.61,0,0,0,.84-1.69h6.84v5.11A8,8,0,0,1,71.51,937.69Z",
    style: {
      fill: "#e7e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.66,940.21a4,4,0,0,0,3.9,2.37,5.85,5.85,0,0,0,.85-.07v-2.9A22.52,22.52,0,0,1,51.66,940.21Z",
    style: {
      fill: "#e7e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.51,927.23a6.71,6.71,0,0,0-6.27,3.54,7.83,7.83,0,0,1,.84,1.69h6.84v-5.11A8,8,0,0,0,71.51,927.23Z",
    style: {
      fill: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.42,
    cy: 930.04,
    r: 1.17,
    style: {
      fill: "#35858a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.47,
    cy: 924.69,
    r: 1.06,
    style: {
      fill: "#9bc6de"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.53,
    cy: 918.26,
    r: 1.06,
    style: {
      fill: "#9bc6de"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.84,
    cy: 920.55,
    r: 1.06,
    style: {
      fill: "#9bc6de"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 914.91,
    r: 1.06,
    style: {
      fill: "#9bc6de"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.25,
    cy: 910.8,
    r: 1.06,
    style: {
      fill: "#9bc6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.12,862.36c.13.63.54,1.67-.17,2.42s-3,1.33-2.79,3.46,2.59,21,2.63,21.59,0,1.13.58,1.13h1.79c.55,0,1,0,1-1.05s.55-16.46.55-17.29.08-1.09.66-1.17a.4.4,0,0,1,.36.13c-1.09-2.32-4.26-10.19-4.88-11.57C124,861.3,124.09,862.2,124.12,862.36Z",
    style: {
      fill: "#a6867b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.12,865.43a6.26,6.26,0,0,0-2.61,1.57c-.43.57-1.69,3.66-1.09,5.79,0-.5.37-1.66,1.29-1.54s2,.92,2,1.5.12,1,.58,1.13.75.08.84-.42.58-2,1.58-2a2.45,2.45,0,0,1,1.92.83c.41.42.37.58,1.08.46a1.08,1.08,0,0,0,.79-1.25c-.08-.29-.62-1.33.17-1.54s3.25-2.34,3.5-3.21.38-1.25,1.7-1.27C151.4,865.27,140.3,865.43,140.12,865.43Z",
    style: {
      fill: "#ca9381"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.47,866a2.52,2.52,0,0,0-1.07,2.25c.17,2.12,2.58,21,2.63,21.59s-.05,1.13.58,1.13h1.79c.54,0,1,0,1-1.05s.54-16.46.54-17.29.09-1.09.67-1.17a.4.4,0,0,1,.36.13C177.59,870.91,171.47,866,171.47,866Z",
    style: {
      fill: "#a6867b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.06,838.51c-1,3.49,2.12,7.86,7.69,9.87h0a3,3,0,0,1,1.42-1.13l-.13-.06C193.71,846,189,843,188.06,838.51Z",
    style: {
      fill: "#8a6459"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.42,840l-6.64-4.78a10.82,10.82,0,0,1-1.05-1.62,15.1,15.1,0,0,0-2.27-2.18,29.54,29.54,0,0,0-3.81-2.75c-.48-.17-1.37-.49-1.37-1.06s.32-1.05.89-1,5.18.73,5.91.89,2.1-.34.73-.9a83.71,83.71,0,0,0-8.34-2.5c-1.14-.16-2.51.08-2.19,1.38a18.8,18.8,0,0,1,.49,3.4c0,.48-.33,1.32-.91,1.37s-1.34-.17-1.34-1.46.34-2-1.45-3.38-2.26-1.75-3-1.35-1.16,3.52-.37,4.73,1.29,1.62,1.33,2,.29,1-.41,1l-10.51.2h0s-10.39,5.21-20.62,4-15.92,3.25-17.63,7.44,4.06,4.1,4.19,10.66-3.63,10.76-4.92,11.33c.18,0,11.28-.16,11.71,0,.18,0,.4,0,.64,0,1.91.12,15.33-.11,16-.1,1,0,3.08-.13,3,.63,0,0,6.12,4.92,6.5,5.59s5.76,18.46,5.89,18.71.17.67.72.67h2c.71,0,.71-1.17.71-1.92s-2.16-24.61-2-25.11,1.79-2.38,2.5-3.92,4.86-6.74,5.24-7.4a27.55,27.55,0,0,1,2.21-3.63c.15-.16.3-.38.48-.6h0c-5.57-2-8.67-6.38-7.69-9.87.89,4.46,5.65,7.46,9,8.68l.13.06a2.44,2.44,0,0,1,.93-.13c1.7.08,5,.56,6.08,0s2.51-1.86,4-1.53,2.35.95,3.16-.05a36.91,36.91,0,0,0,2.43-3.76A1.3,1.3,0,0,0,213.42,840Z",
    style: {
      fill: "#a6867b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,854.1c-.13-6.56-5.89-6.46-4.19-10.66s7.39-8.62,17.63-7.44,20.62-4,20.62-4h0c-18,.35-53,1.06-53.73,1.09-.92,0-3,.37-3.58,2.17a79,79,0,0,0-1.92,9.46c-.17,1.5-2.17,15.17-2.33,15.92s-1.76,4.46-2.09,5.42a9.27,9.27,0,0,0,0,4.54c.42,1.34.83,2.5,1.42,2.5s1-1.91,1.58-3a7.3,7.3,0,0,0,1.25-5c-.41-2-.71-2.5-.5-3.46s2.34-13.05,2.5-13.55.8-.75.92.17c.09.69.82,7.93,1.23,11.78.62,1.38,3.79,9.25,4.88,11.57a6.08,6.08,0,0,1,.66,1.59c.14.27,6.5,14.76,7.32,17.2.17.5.23.59.8.59h1.9c.5,0,1.09,0,.88-.88s-3.83-16.79-3.87-17.29c-.6-2.13.66-5.22,1.09-5.79a6.26,6.26,0,0,1,2.61-1.57C141.41,864.86,145.17,860.66,145,854.1Z",
    style: {
      fill: "#a6867b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.2,876.67c.48-.24,3-1.07,4-2.55s3.67-4.81,6.28-5a134.14,134.14,0,0,1,8.54-11.33c.47-.53,2.37-1.3,2.61-1.66s12.63-7.94,25.2-7.94,19.33,1.24,24.72,5.27c.09.24.6,1.52.86,2.39a12.84,12.84,0,0,0,.48,2l-.35-.62s-5.06-1-5.8-1.35-4.48-.45-8,1.88-13.65,3-18.38,2.75-2.79,8.12-6,11c-.2.06-.32.17-.32.32L248,872a62.25,62.25,0,0,0-4.82,4.15c-.27.48-4.41,14.12-4.5,14.31s-.14.51-.56.51h-1.55c-.54,0-.54-.9-.54-1.47,0-.37.69-8.07,1.14-13.6a56.6,56.6,0,0,0,.86-10.12c-.81,3.52-.89,10.48-3.26,14.75-.83,1.25-7.89,7-9.43,6.7a12.72,12.72,0,0,1-3.79-1.54c-.42-.3-.6-.59,0-1.13a5.43,5.43,0,0,0,1.48-1.72,23.48,23.48,0,0,0,.24-5.42c-.24-.74-.42-1.63-.54-1.81s-.53-.24-1,0-6.87,2.13-7.53,2S213.73,876.9,214.2,876.67Z",
    style: {
      fill: "#f1d6c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1,871.87a1.9,1.9,0,0,1,.82,1.71c-.13,1.63-2,16.07-2,16.52s0,.86-.45.86h-1.37c-.41,0-.76,0-.76-.8s-.42-12.59-.42-13.23-.06-.83-.51-.89a.28.28,0,0,0-.27.1C243.42,875.62,248.1,871.87,248.1,871.87Z",
    style: {
      fill: "#f1d6c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.94,847.44a2.26,2.26,0,0,0-.59.45A2.26,2.26,0,0,1,285.94,847.44Z",
    style: {
      fill: "#f2e5dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.34,848.73a.74.74,0,0,1,1.09-.06A.74.74,0,0,0,286.34,848.73Z",
    style: {
      fill: "#f2e5dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.57,847.54a1.93,1.93,0,0,0-.58-.27A1.93,1.93,0,0,1,288.57,847.54Z",
    style: {
      fill: "#f2e5dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,847.15a2.86,2.86,0,0,1,1,.12A2.86,2.86,0,0,0,287,847.15Z",
    style: {
      fill: "#f2e5dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.67,849.47a3.1,3.1,0,0,1,.24-.92,2.06,2.06,0,0,1,.44-.66,2.26,2.26,0,0,1,.59-.45,2.7,2.7,0,0,1,1-.29,2.86,2.86,0,0,1,1,.12,1.93,1.93,0,0,1,.58.27,1.46,1.46,0,0,1,.42.4L287.74,849a1.42,1.42,0,0,0-.31-.36.74.74,0,0,0-1.09.06.73.73,0,0,0-.18.74c.26.59,1.61.8,1.68.81a5.81,5.81,0,0,1-1.38,1.75l-.31-.28a4,4,0,0,1-1.45-1.88A1,1,0,0,1,284.67,849.47Z",
    style: {
      fill: "#f1d6c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.55,850.32c.77-.1,2.12-.43,2.17-1.49.87,1.44.12,4.12-3.21,3.67A4.64,4.64,0,0,0,289.55,850.32Z",
    style: {
      fill: "#f1d6c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,870.36h0a1.13,1.13,0,0,0,.29.59c.54.57,2.26,1,2.13,2.64s-2,16.07-2,16.52,0,.86-.44.86h-1.37c-.42,0-.77,0-.77-.8s-.41-12.59-.41-13.23-.07-.83-.51-.89a.3.3,0,0,0-.28.1h0C280.86,876,283.7,871.18,284.15,870.36Z",
    style: {
      fill: "#f1d6c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.12,875.89a52.09,52.09,0,0,1-2.4,4.63c2.37-4.27,2.45-11.23,3.26-14.75A56.6,56.6,0,0,1,237.12,875.89Z",
    style: {
      fill: "#f6d7cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,871.51l0,0-.28.28C248.11,871.68,248.23,871.57,248.43,871.51Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,860.5c4.73.2,14.86-.43,18.38-2.75s7.28-2.26,8-1.88,5.8,1.35,5.8,1.35l.35.62c.11.4.22.78.28,1.12.82,4.21-2,9.56-3.06,11.4-.45.82-3.29,5.6-3.37,5.78h0a4.69,4.69,0,0,0-.5,1.21c-.11.21-5,11.29-5.6,13.16-.13.38-.17.45-.61.45h-1.45c-.38,0-.84,0-.68-.67s2.93-12.84,3-13.22a6.89,6.89,0,0,0-.84-4.44,5.11,5.11,0,0,0-2-1.2c-.15,0-8.63-.11-9,0a4.44,4.44,0,0,0-.49,0c-1.46.09-11.72-.09-12.23-.07a8.07,8.07,0,0,0-2,.12C251.6,868.62,249.69,860.3,254.39,860.5Z",
    style: {
      fill: "#f1d6c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.63,856.48a.5.5,0,0,1,0,.13,6.85,6.85,0,0,1-.14-.74c-.26-.87-.77-2.15-.86-2.39l-.12-.08-.1-.34,1.09-1h0l.37-.38.12-.12c.12-.12.22-.25.33-.37l.06-.07c.1-.13.19-.26.27-.38l0,0a2.4,2.4,0,0,0,.2-.39h0a1.28,1.28,0,0,0-.1-1.25l1.25-1.09c1.14,1.61.74,3.72-1.57,5.7A3,3,0,0,0,286.63,856.48Z",
    style: {
      fill: "#f1d6c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.46,817.23c0,11.77,7.25,21.31,16.2,21.31V795.92C315.71,795.92,308.46,805.46,308.46,817.23Z",
    style: {
      fill: "#75ad87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.66,795.92v42.62c8.94,0,16.19-9.54,16.19-21.31S333.6,795.92,324.66,795.92Z",
    style: {
      fill: "#479260"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.66,808v70.9c14.87,0,26.93-15.87,26.93-35.45S339.53,808,324.66,808Z",
    style: {
      fill: "#479260"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.73,843.47c0,19.58,12,35.45,26.93,35.45V808C309.78,808,297.73,823.89,297.73,843.47Z",
    style: {
      fill: "#75ad87"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.66,
    y: 863.13,
    width: 3.35,
    height: 27.83,
    style: {
      fill: "#a6a699"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.31,
    y: 863.13,
    width: 3.35,
    height: 27.83,
    style: {
      fill: "#83847a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,869.06c.48,0,.89,0,1.31,0,.08,0,.18.16.22.27.79,2.08,1.57,4.17,2.36,6.25a.77.77,0,0,0,.18.33c0-2.29-.05-4.58-.08-6.9l1.34,0c0,2.31.06,4.59.09,6.87h.07c.8-2.29,1.59-4.58,2.4-6.91l1.43,0-4.5,13c-1.62-4.34-3.21-8.57-4.82-12.86",
    style: {
      fill: "#5c9e6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.38,887.24a3.74,3.74,0,0,0,.07-1.29,2.77,2.77,0,0,0-2.88-2.33h-9.11a2.82,2.82,0,0,0-2.8,3.64c.33,1.23.66,2.46,1,3.7h12.77C359.93,889,360.33,887.47,360.38,887.24Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,911.18a1.6,1.6,0,0,0,.26.58.88.88,0,0,0,1,.31,1,1,0,0,0,.76-.83c.81-3,4.44-16.67,5.39-20.28H346.64l.15.56Q349.42,901.35,352,911.18Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.43,869.06c.47,0,.89,0,1.31,0,.08,0,.18.16.22.27.79,2.08,1.57,4.17,2.35,6.25a.79.79,0,0,0,.19.33c0-2.29-.06-4.58-.08-6.9l1.34,0c0,2.31.06,4.59.08,6.87h.08c.79-2.29,1.59-4.58,2.4-6.91l1.42,0c-1.49,4.32-3,8.59-4.49,13l-4.82-12.86",
    style: {
      fill: "#5c9e6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.76,887.24a3.51,3.51,0,0,0,.07-1.29,2.76,2.76,0,0,0-2.87-2.33h-9.12a2.82,2.82,0,0,0-2.79,3.64c.32,1.23.65,2.46,1,3.7H377.8C378.32,889,378.72,887.47,378.76,887.24Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.41,911.18a2,2,0,0,0,.26.58.9.9,0,0,0,1,.31,1,1,0,0,0,.76-.83c.8-3,4.43-16.67,5.39-20.28H365l.15.56Q367.79,901.35,370.41,911.18Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,869.06c.48,0,.9,0,1.31,0,.08,0,.18.16.22.27.79,2.08,1.57,4.17,2.36,6.25a.77.77,0,0,0,.18.33c0-2.29-.05-4.58-.08-6.9l1.34,0c0,2.31.06,4.59.09,6.87h.07c.8-2.29,1.59-4.58,2.4-6.91l1.43,0-4.5,13c-1.62-4.34-3.21-8.57-4.82-12.86",
    style: {
      fill: "#5c9e6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.37,887.24a3.74,3.74,0,0,0,.07-1.29,2.77,2.77,0,0,0-2.88-2.33h-9.11a2.82,2.82,0,0,0-2.8,3.64c.33,1.23.66,2.46,1,3.7h12.78C396.92,889,397.32,887.47,397.37,887.24Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,911.18a1.6,1.6,0,0,0,.26.58.88.88,0,0,0,1,.31,1,1,0,0,0,.77-.83c.8-3,4.43-16.67,5.39-20.28H383.63c.05.18.11.37.16.56Q386.4,901.35,389,911.18Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.01,
    y1: 890.96,
    x2: 353.01,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.05,
    y1: 879.96,
    x2: 355.75,
    y2: 49.95,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,10.993648529052734"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.77,
    y1: 44.45,
    x2: 355.77,
    y2: 44.45,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.94,
    y1: 890.96,
    x2: 324.94,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.98,
    y1: 879.99,
    x2: 327.62,
    y2: 52.08,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,10.96578598022461"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.63,
    y1: 46.59,
    x2: 327.63,
    y2: 46.59,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.87,
    y1: 890.96,
    x2: 296.87,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.91,
    y1: 880.02,
    x2: 299.48,
    y2: 54.21,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,10.937923431396484"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.5,
    y1: 48.74,
    x2: 299.5,
    y2: 48.74,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.8,
    y1: 890.96,
    x2: 268.8,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.84,
    y1: 879.9,
    x2: 271.35,
    y2: 56.41,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,11.053613662719727"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.36,
    y1: 50.88,
    x2: 271.36,
    y2: 50.88,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.73,
    y1: 890.96,
    x2: 240.73,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.76,
    y1: 879.93,
    x2: 243.21,
    y2: 58.54,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,11.025383949279785"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.23,
    y1: 53.03,
    x2: 243.23,
    y2: 53.03,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.66,
    y1: 890.96,
    x2: 212.66,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.69,
    y1: 879.96,
    x2: 215.08,
    y2: 60.67,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,10.99715518951416"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.1,
    y1: 55.18,
    x2: 215.1,
    y2: 55.18,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.59,
    y1: 890.96,
    x2: 184.59,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.62,
    y1: 879.99,
    x2: 186.95,
    y2: 62.81,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,10.968925476074219"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.96,
    y1: 57.32,
    x2: 186.96,
    y2: 57.32,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.52,
    y1: 890.96,
    x2: 156.52,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.55,
    y1: 880.02,
    x2: 158.81,
    y2: 64.94,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,10.940695762634277"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.83,
    y1: 59.47,
    x2: 158.83,
    y2: 59.47,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.44,
    y1: 890.96,
    x2: 128.44,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.47,
    y1: 879.9,
    x2: 130.68,
    y2: 67.14,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,11.057966232299805"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.69,
    y1: 61.61,
    x2: 130.69,
    y2: 61.61,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.37,
    y1: 890.96,
    x2: 100.37,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.4,
    y1: 879.93,
    x2: 102.54,
    y2: 69.27,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,11.0293607711792"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.56,
    y1: 63.76,
    x2: 102.56,
    y2: 63.76,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.3,
    y1: 890.96,
    x2: 72.3,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.33,
    y1: 879.96,
    x2: 74.41,
    y2: 71.4,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,11.000755310058594"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.42,
    y1: 65.9,
    x2: 74.42,
    y2: 65.9,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.23,
    y1: 890.96,
    x2: 44.23,
    y2: 890.96,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.26,
    y1: 879.98,
    x2: 46.27,
    y2: 73.53,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,10.972149848937988"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.29,
    y1: 68.05,
    x2: 46.29,
    y2: 68.05,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.74,
    cy: 334.88,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.18,
    cy: 317.9,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.22,
    cy: 434.73,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.64,
    cy: 281.36,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.77,
    cy: 214.07,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.26,
    cy: 265.3,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.92,
    cy: 430.06,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.26,
    cy: 689.18,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.39,
    cy: 214.07,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.91,
    cy: 241.58,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.37,
    cy: 377.84,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.25,
    cy: 397.8,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.25,
    cy: 717.15,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.94,
    cy: 550.97,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.94,
    cy: 802.93,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.26,
    cy: 573.96,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.18,
    cy: 848.83,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.76,
    cy: 445.66,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1074.13V945.58l105.94-10c0,123.76,294.06,28.54,294.06,138.55",
    style: {
      fill: "#9bc6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.42,18.55a29.68,29.68,0,0,1,14.29,3.64,29.74,29.74,0,0,1,40-23A48.76,48.76,0,0,1,328.5-8.46,29.82,29.82,0,1,1,350,42a29.75,29.75,0,0,1-23.85-12,48.76,48.76,0,0,1-43.55,26.86A48.58,48.58,0,0,1,249,43.44a29.83,29.83,0,0,1-39.21,9.81,29.82,29.82,0,1,1-29.41-34.7Z",
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.32,
    cy: -10.01,
    r: 40.28,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.41,
    cy: 24.48,
    r: 40.28,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.22,
    cy: 2.33,
    r: 20.14,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.22,
    cy: 2.33,
    r: 20.14,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400-37.95V-45.5H0v7.55A20.13,20.13,0,0,1,20-19.73l10.44-1,29.94,37.6,41,27.58,44.22-9.12,56.72-7.17L379.94-16.16c0-.55-.08-1.09-.08-1.65A20.14,20.14,0,0,1,400-37.95Z",
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.86-17.81v30s-40.28-18.85-40.28-30a20.14,20.14,0,0,1,20.14-20.14A20.14,20.14,0,0,1,379.86-17.81Z",
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.73,
    cy: -17.81,
    r: 39.59,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.12,
    cy: -3.27,
    r: 20.14,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.26,62.09A29.75,29.75,0,0,0,228,65.73a29.75,29.75,0,0,0-40-23,48.76,48.76,0,0,0-93.82-7.64A29.85,29.85,0,1,0,82.49,83.84a33.84,33.84,0,0,0,57.87,16.58A48.6,48.6,0,0,0,173.64,87a29.8,29.8,0,0,0,39.21,9.81,29.82,29.82,0,1,0,29.41-34.7Z",
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.16,68.41a2.06,2.06,0,0,0,2.6-.06l1.91,1.51c-.08.12-.15.24-.22.37a4.57,4.57,0,0,0,1.56,6l-1.24,2.35a3.06,3.06,0,1,0,.74.39l1.24-2.34a4.58,4.58,0,0,0,6.32-4l2.64-.1a3.05,3.05,0,0,0,6.06-.66,3,3,0,0,0-1-2.12,2.85,2.85,0,0,0-.65-.46,3.05,3.05,0,0,0-4.46,2.4l-2.65.1a4.58,4.58,0,0,0-2.4-3.45,4.49,4.49,0,0,0-2.49-.51l-.63-2.91a3.07,3.07,0,0,0,1.94-3.51,3.11,3.11,0,0,0-1.33-1.93l-.24-.13a3,3,0,0,0-2.06-.28,3,3,0,0,0-2.34,3.63h0a3.06,3.06,0,0,0,3.21,2.4l.63,2.87a4.7,4.7,0,0,0-2.13,1.26l-1.92-1.51a2,2,0,0,0,.2-1.17,2.09,2.09,0,0,0-.78-1.37,2,2,0,0,0-.31-.19,2,2,0,0,0-1.21-.22,2,2,0,0,0-1.37.78A2.06,2.06,0,0,0,131.16,68.41Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.77,40.36a1,1,0,0,0,1.18,0l.87.68-.1.17a2.07,2.07,0,0,0,.7,2.71L173.86,45a1.38,1.38,0,0,0-1.11,2.53,1.38,1.38,0,0,0,1.45-2.35l.56-1.07a2.07,2.07,0,0,0,2.87-1.81l1.21,0a1.38,1.38,0,0,0,2.38.7,1.38,1.38,0,0,0-.08-2,1.94,1.94,0,0,0-.29-.21,1.44,1.44,0,0,0-.7-.16,1.4,1.4,0,0,0-1.33,1.25l-1.2.05a2.11,2.11,0,0,0-1.09-1.57,2.08,2.08,0,0,0-1.13-.23l-.29-1.33a1.38,1.38,0,0,0,.88-1.59,1.4,1.4,0,0,0-.61-.87l-.1-.07a1.4,1.4,0,0,0-2,1.53h0a1.41,1.41,0,0,0,1.47,1.09l.28,1.3a2.16,2.16,0,0,0-1,.58l-.87-.69a1,1,0,0,0,.09-.53.93.93,0,0,0-.35-.62l-.14-.09a.9.9,0,0,0-.56-.1.94.94,0,0,0-.62.35A1,1,0,0,0,171.77,40.36Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.18,6.62a.93.93,0,0,0,1.18,0l.87.69-.1.17a2.09,2.09,0,0,0,.71,2.71l-.56,1.06a1.39,1.39,0,1,0,.34.18l.56-1.06a2.08,2.08,0,0,0,2.63-1,2,2,0,0,0,.24-.85l1.2,0a1.4,1.4,0,0,0,2.39.7,1.4,1.4,0,0,0-.08-2,1,1,0,0,0-.3-.21,1.29,1.29,0,0,0-.7-.16,1.38,1.38,0,0,0-1.32,1.25l-1.21,0a2,2,0,0,0-1.09-1.56,2.07,2.07,0,0,0-1.13-.24L305.52,5a1.39,1.39,0,0,0,.88-1.6,1.34,1.34,0,0,0-.6-.87l-.11-.06a1.38,1.38,0,0,0-2,1.52h0a1.38,1.38,0,0,0,1.46,1.09l.29,1.31a2.09,2.09,0,0,0-1,.57l-.87-.69a1,1,0,0,0,.09-.53.91.91,0,0,0-.36-.62l-.14-.09a1,1,0,0,0-.55-.1.91.91,0,0,0-.62.36A.94.94,0,0,0,302.18,6.62Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.21,28.77a.93.93,0,0,0,1.18,0l.87.69-.1.17a2.09,2.09,0,0,0,.71,2.71l-.56,1.06a1.4,1.4,0,0,0-1.7.66,1.38,1.38,0,0,0,.58,1.87,1.39,1.39,0,0,0,1.46-2.35l.56-1.07a2.07,2.07,0,0,0,2.63-.95,2,2,0,0,0,.24-.86l1.2,0a1.39,1.39,0,1,0,2.31-1.27,1.61,1.61,0,0,0-.3-.21,1.39,1.39,0,0,0-2,1.1l-1.21,0A2.08,2.08,0,0,0,268,28.72a2.15,2.15,0,0,0-1.13-.23l-.29-1.32a1.39,1.39,0,0,0,.88-1.6,1.34,1.34,0,0,0-.6-.87l-.11-.06a1.38,1.38,0,0,0-2,1.52h0a1.36,1.36,0,0,0,.61.87,1.34,1.34,0,0,0,.85.22l.29,1.31a2,2,0,0,0-1,.57l-.87-.69a.92.92,0,0,0-.27-1.15l-.14-.09a1,1,0,0,0-.55-.1.91.91,0,0,0-.62.36A.94.94,0,0,0,263.21,28.77Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,16a.93.93,0,0,0,1.18,0l.87.69a1,1,0,0,0-.1.17,2.09,2.09,0,0,0,.71,2.71l-.56,1.06a1.4,1.4,0,1,0,.33.18l.56-1.07a2.08,2.08,0,0,0,2.64-.95,2.22,2.22,0,0,0,.24-.86l1.2,0A1.39,1.39,0,0,0,241.47,19a1.35,1.35,0,0,0,1-.44,1.4,1.4,0,0,0-.07-2,1.61,1.61,0,0,0-.3-.21,1.4,1.4,0,0,0-2,1.1l-1.2,0A2.1,2.1,0,0,0,237.74,16a2.06,2.06,0,0,0-1.13-.23l-.29-1.32A1.39,1.39,0,0,0,236.6,12l-.11-.06a1.34,1.34,0,0,0-.94-.13,1.39,1.39,0,0,0-1.06,1.65h0A1.39,1.39,0,0,0,236,14.5l.28,1.31a2,2,0,0,0-1,.57l-.88-.69a.81.81,0,0,0,.09-.53.89.89,0,0,0-.35-.62.55.55,0,0,0-.14-.09.94.94,0,0,0-1.18.26A.94.94,0,0,0,233,16Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.69,80.2a.91.91,0,0,0,1.17,0l.87.69-.1.17a2.09,2.09,0,0,0,.71,2.71l-.56,1.07a1.39,1.39,0,0,0-1.12,2.53A1.39,1.39,0,0,0,205.12,85l.56-1.06a2.08,2.08,0,0,0,2.87-1.81l1.2,0a1.4,1.4,0,0,0,2.39.7,1.4,1.4,0,0,0-.08-2,1,1,0,0,0-.3-.21,1.29,1.29,0,0,0-.7-.16,1.38,1.38,0,0,0-1.32,1.25l-1.21,0a2.07,2.07,0,0,0-2.22-1.8L206,78.6A1.37,1.37,0,0,0,206.9,77a1.34,1.34,0,0,0-.6-.88l-.11-.06a1.39,1.39,0,0,0-.94-.13,1.4,1.4,0,0,0-1.06,1.65h0a1.35,1.35,0,0,0,.61.88,1.34,1.34,0,0,0,.85.21l.29,1.31a2.09,2.09,0,0,0-1,.57l-.87-.69a.92.92,0,0,0-.27-1.15l-.14-.09a1,1,0,0,0-.55-.1.91.91,0,0,0-.62.36A.93.93,0,0,0,202.69,80.2Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.24,76.74a1,1,0,0,0,1.3,0l.95.75a1.18,1.18,0,0,0-.11.19,2.29,2.29,0,0,0,.77,3l-.61,1.17a1.52,1.52,0,0,0-1.23,2.77,1.52,1.52,0,0,0,1.6-2.58l.61-1.17a2.28,2.28,0,0,0,3.15-2l1.32,0a1.52,1.52,0,1,0,2.52-1.39,1.44,1.44,0,0,0-.32-.23,1.55,1.55,0,0,0-.77-.17A1.53,1.53,0,0,0,327,78.36l-1.32,0a2.27,2.27,0,0,0-1.2-1.72,2.33,2.33,0,0,0-1.23-.25L322.9,75a1.52,1.52,0,0,0,.3-2.71l-.11-.07a1.53,1.53,0,0,0-2.2,1.67h0a1.5,1.5,0,0,0,.67,1,1.55,1.55,0,0,0,.93.24l.31,1.43a2.28,2.28,0,0,0-1.05.63l-1-.76a1.05,1.05,0,0,0,.1-.58,1,1,0,0,0-.39-.68l-.15-.1a1.17,1.17,0,0,0-.61-.11,1.08,1.08,0,0,0-.68.39A1,1,0,0,0,319.24,76.74Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.77,116.9a.93.93,0,0,0,1.18,0l.87.69a1,1,0,0,0-.1.17,2.07,2.07,0,0,0,.7,2.71l-.56,1.06a1.39,1.39,0,1,0,.34.18l.56-1.06a2.1,2.1,0,0,0,2.64-1,2,2,0,0,0,.23-.86l1.21,0a1.39,1.39,0,0,0,1.42,1.14,1.35,1.35,0,0,0,1-.44,1.43,1.43,0,0,0,.37-1,1.36,1.36,0,0,0-.45-1,1.48,1.48,0,0,0-.29-.22,1.43,1.43,0,0,0-.7-.15,1.39,1.39,0,0,0-1.33,1.25l-1.2,0a2.09,2.09,0,0,0-2.22-1.8l-.29-1.32a1.38,1.38,0,0,0,.27-2.47l-.1-.06a1.39,1.39,0,0,0-2,1.52h0a1.41,1.41,0,0,0,1.47,1.09l.28,1.31a2.14,2.14,0,0,0-1,.57l-.87-.69a1,1,0,0,0,.09-.53.93.93,0,0,0-.35-.62l-.14-.09a1,1,0,0,0-.56-.1,1,1,0,0,0-.62.36A.94.94,0,0,0,171.77,116.9Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.77,
    cy: 36.06,
    r: 40.28,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.66,
    cy: 35.51,
    r: 32.54,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.96,
    cy: 13.61,
    r: 65.9,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.83,
    cy: 13.61,
    r: 48.69,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.03,
    cy: 47.36,
    r: 39.61,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.43,
    cy: 19.32,
    r: 57.43,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.75,
    cy: 19.32,
    r: 35.84,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.64,
    cy: 98.33,
    r: 16.12,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.67,
    cy: 93.39,
    r: 22.82,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.37,
    cy: 87.05,
    r: 29.52,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.52,
    cy: 60.08,
    r: 22.27,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.27,
    cy: 80.03,
    r: 40.12,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.64,
    cy: 75.09,
    r: 47.24,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.65,
    cy: 91.99,
    r: 35.61,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.79,
    cy: 146.87,
    r: 13.36,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.23,
    cy: 93.39,
    r: 13.36,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.58,
    cy: 98.33,
    r: 13.36,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.55,
    cy: 131.31,
    r: 20.21,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.25,
    cy: 108.88,
    r: 20.21,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.57,
    cy: 118.54,
    r: 20.21,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.64,
    cy: 115.94,
    r: 28.89,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.34,
    cy: 111.1,
    r: 28.89,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.04,
    cy: 118.54,
    r: 23.41,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.77,
    cy: 104.24,
    r: 8.37,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.28,
    cy: 95.44,
    r: 19.35,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.57,
    cy: 85.34,
    r: 12.34,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.12,
    cy: 46.55,
    r: 19.35,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.14,
    y: -132.4,
    width: 399.72,
    height: 146.01,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.34,
    cy: 33.17,
    r: 34.19,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.97,
    cy: 19.32,
    r: 34.19,
    style: {
      fill: "#7b7768"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.36,
    cy: 35.51,
    r: 29.18,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.53,
    cy: 126.75,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.76,
    cy: 108.88,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.76,
    cy: 75.66,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.85,
    cy: 15.08,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.88,
    cy: 5.37,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.92,
    cy: 57.48,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.25,
    cy: 37.81,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.04,
    cy: 8.28,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.64,
    cy: 61.6,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDioxin05);
export default __webpack_public_path__ + "static/media/dioxin_05.2dff856d6c4cff43d4da720594017f70.svg";
export { ForwardRef as ReactComponent };